import csi from "csi/main";
import { C8NodeType } from "csi/typings";
import util from "csi/util";
import { View } from "./View";
import { DefElement } from "csi/utility/defUtility";

// mapping of view types to class constructor
const _factoryViews: Record<string, string> = {};

/** register new view types with view factory */
export function register(obj: Record<string, string>): void {
	Object.assign(_factoryViews, obj);
}

/** create new view given XML definition based on type */
export function create(def: DefElement, typeView?: string, typeNode?: C8NodeType): View {
	const type = typeView || util.getProperty(def, "xsi:type");
	if (!type) {
		console.warn("Unrecognized defView: ", def);
		return null;
	}

	// view class constructor may either be in factory or the class name itself
	const ctr = csi.syncRequire(_factoryViews[type] || type);

	if (typeof ctr !== "function") {
		console.warn("Cannot create defView: ", def);
		return null;
	}

	// FIX: should translate def to JSON before calling constructor - remove all csi.def.* classes
	// in favor of just using JSON model and API into object structure
	const viewDef = new ctr(def);
	viewDef.m_typeView = type;
	viewDef.m_idType = def ? (typeNode || null) : typeNode;
	return viewDef;
}
